module.exports = __webpack_public_path__ + "static/media/paste.8dbbce88.svg";